import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';

const PATH_DOCS = '/docs';

export const DocsRoutesConfig: { [key: string]: RouteConfiguration } = {
  Index: {
    path: PATH_DOCS,
    generatePath: () => PATH_DOCS,
  },
};

const LoadableDocsContainer: LoadableComponent<any> = loadable(
  async () => import('./screens').then(module => module.Docs),
  { fallback: <QueryLoadingAbsolute /> },
);

export function DocsRoutes() {
  return (
    <Route
      path={DocsRoutesConfig.Index.path}
      exact={true}
      component={LoadableDocsContainer}
    />
  );
}
